import { ReactNode, useCallback, useEffect, useState } from "react";
import { GlobalOptionsContext, IGlobalOptions } from "../../contexts/GlobalOptionsContext";

export const GlobalOptionsProvider = ({ children }: { children: ReactNode }) => {
  const [globalOptions, setGlobalOptions] = useState<IGlobalOptions>({
    whitelabel_color: "#FF0000",
    whitelabel_name: "Expedient",
    whitelabel_darklogo: "/logo-dark.png",
    whitelabel_lightlogo: "/logo-light.png",
    whitelabel_loginlogo: "/logo-light.png",
    openwebui_url: undefined,
  });
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);

  const reload = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(((process.env.REACT_APP_LLMGATEWAY_HOST ?? "") + "/chat-config/global_options"));
      if (!response.ok) {
        throw new Error(`Failed to fetch global options: ${response.status}`);
      }
      const data = await response.json();
      setGlobalOptions({
        whitelabel_color: data.whitelabel_color ?? "#FF0000",
        whitelabel_name: data.whitelabel_name ?? "Expedient",
        whitelabel_darklogo: data.whitelabel_darklogo ?? "/logo-dark.png",
        whitelabel_lightlogo: data.whitelabel_lightlogo ?? "/logo-light.png",
        whitelabel_loginlogo: data.whitelabel_loginlogo ?? "/logo-light.png",
        openwebui_url: data.openwebui_url ?? undefined,
      });
    } catch (err) {
      setError(err as Error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void reload();
  }, [reload]);

  return (
    <GlobalOptionsContext.Provider
      value={{
        globalOptions,
        loading,
        error,
        reload,
        name: "global options",
      }}
    >
      {children}
    </GlobalOptionsContext.Provider>
  );
}; 